// src/pages/Monuments/DistrictMonuments.jsx

import React, { useState, useEffect } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { useSelector } from "react-redux";
import districtData from "../../Attraction/monument/districtData";
import PropTypes from "prop-types";
const FortCard = ({ fort, navigate, divisionName, districtName }) => (
  <div className="bg-[#F6F6EC] border border-[#F8D6BF] rounded-xl shadow-md p-4 w-[270px] text-center font-futura">
    <img
      src={fort.imageGroup}
      alt={fort.title}
      className={`w-full h-48 object-cover rounded-md mb-4`}
    />
    <h2 className="text-[17px] font-medium ">{fort.title}</h2>
    {/* <p className="text-[14px] mb-2">{fort.location}</p>
    <p className="text-[14px] font-medium mb-1"><strong>{fort.statusLabel}</strong> {fort.status}</p>
    <p className="text-[14px] font-medium mb-1"><strong>{fort.notificationLabel}</strong> {fort.notification}</p>
    <p className="text-[14px] font-medium mb-4"><strong>{fort.typeLabel}</strong> {fort.type}</p> */}
    <button
      onClick={() => navigate(`/monuments/${divisionName}/${districtName}/${fort.id}`)}
      className="bg-[#D39100] text-white py-1 px-4 rounded-full hover:bg-[#c27f00] transition mt-4"
    >
      {fort.button}
    </button>

  </div>
);


const DistrictMonuments = () => {
  const { divisionName, districtName } = useParams(); // e.g., ratanagirimonument / palghar
  const selectedLang = useSelector((state) => state.language.selectedLang);
  const navigate = useNavigate();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [fade, setFade] = useState(true);

  const district = districtData[districtName];
  const langData = district ? district[selectedLang] : null;

  useEffect(() => {
    if (!langData) return;

    const maxImages = Math.max(...langData.cards.map((card) => card.imageGroup.length));
    let timeoutId;
    const updateIndex = () => {
      setCurrentIndex((prev) => (prev + 1) % maxImages);
      setFade(true);
    };
    const updateImageIndex = () => {
      setFade(false);
      timeoutId = setTimeout(updateIndex, 300);
    };
    const intervalId = setInterval(updateImageIndex, 2000);

    return () => {
      clearInterval(intervalId);
      clearTimeout(timeoutId);
    };
  }, [langData]);

  if (!langData) return <p className="text-center mt-20">Invalid District</p>;

  return (
    <div className="min-h-screen bg-[#fdfbf3] py-12 px-4 sm:px-10 lg:px-20 flex flex-col items-center">
      <div className="text-center mb-8">
        <h1 className="text-[26px] sm:text-4xl md:text-5xl lg:text-[45px] text-black">
          {/* {langData.title} */}
          {selectedLang === "मराठी" ? "स्मारके व पुरास्थळे" : "Monuments and Sites"}
        </h1>
        <p className="font-futura tracking-wider text-sm sm:text-base lg:text-[15px] font-medium mt-8">
          <span style={{ color: "#DD9827" }}>
            <Link to="/" className="hover:underline">
              {langData.breadcrumb}
            </Link>{" "}
            /{" "}
            <Link
              to={`/monuments/${divisionName}`}
              className="hover:underline text-[#DD9827]"
            >
              {langData.breadcrumbmuseum}
            </Link>
            {" "}
            /{" "}
          </span>
          <span className="capitalize">{langData.divisionTitle}</span>
        </p>
      </div>

      <div className="w-full flex flex-wrap justify-center gap-6 ">
        {langData.cards.map((fort) => (
          <FortCard
            key={fort.id}
            fort={fort}
            currentIndex={currentIndex}
            fade={fade}
            navigate={navigate}
            divisionName={divisionName}
            districtName={districtName}
          />
        ))}
      </div>
    </div>
  );
};

FortCard.propTypes = {
  fort: PropTypes.object.isRequired,
  navigate: PropTypes.func.isRequired,
  divisionName: PropTypes.string.isRequired,
  districtName: PropTypes.string.isRequired,
};


export default DistrictMonuments;
